/* TROVI Marketplace · header (Agente A)
   Tres comportamientos, sin dependencias:
   1) Buscador con selector de departamento.
   2) Botón «All» de la fila 2 como proxy del drawer de Dawn.
   3) La fila 2 se pliega al bajar y reaparece al subir (la fila 1 queda fija). */

(function () {
  'use strict';

  var DESKTOP = '(min-width: 990px)';

  /* 1) Buscador -------------------------------------------------------------
     - query vacío + departamento elegido -> navega a la colección.
     - query + departamento -> /search?q=...&type=product&dept=<handle>.
     - query + «All» -> se desactiva el select para no mandar `dept=` vacío. */
  function initSearch(form) {
    var input = form.querySelector('input[type="search"]');
    if (!input || form.dataset.tvSearchBound) return;
    form.dataset.tvSearchBound = 'true';
    var department = form.querySelector('[data-tv-dept]');
    if (department) department.addEventListener('change', function () {
      var selected = department.options[department.selectedIndex];
      if (!selected) return;
      var target = selected.getAttribute('data-url');
      if (!department.value) {
        var action = new URL(form.action, window.location.href);
        if (action.origin !== window.location.origin || !/\/search$/.test(action.pathname)) return;
        target = action.pathname.replace(/\/search$/, '/collections/all');
      }
      if (!target) return;
      var destination = new URL(target, window.location.href);
      if (destination.origin !== window.location.origin ||
          !/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/collections\/[a-z0-9-]+\/?$/i.test(destination.pathname)) return;
      window.location.assign(destination.href);
    });

    form.addEventListener('submit', function (event) {
      var select = form.querySelector('[data-tv-dept]');
      var query = input.value.trim();
      var option = select && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
      var deptUrl = option ? option.getAttribute('data-url') : '';

      if (!query) {
        // Con query vacío el predictive search ya hace preventDefault; navegamos nosotros.
        if (deptUrl) {
          event.preventDefault();
          window.location.assign(deptUrl);
        }
        return;
      }

      // El navegador serializa el formulario después de este evento: desactivar aquí basta.
      if (select && !select.value) select.disabled = true;
    });
  }

  /* 2) Proxy del drawer ----------------------------------------------------- */
  function initDrawerProxy(root) {
    var proxy = root.querySelector('[data-tv-drawer-toggle]');
    var details = root.querySelector('header-drawer > details');
    if (!proxy || !details) return;

    var summary = details.querySelector('summary');
    if (!summary) return;

    var openedByProxy = false;

    /* r87.1: en escritorio el ☰ es `visibility: hidden` (fuera del orden de
       tabulación), así que el foco que Dawn le manda se pierde. Se corrige el
       ciclo entero observando la clase `menu-opening` del <details>, sin tocar
       `summary.focus` (envolverlo desviaba también la apertura: Dawn llama
       `trapFocus(details, summary)` al abrir y el foco se quedaba en «All»,
       fuera del <details>, de modo que Escape no llegaba a su manejador).
         · al abrir  → foco al primer control DEL PANEL y trampa sobre el panel
                       (el ☰ oculto queda fuera, así el ciclo de Tab es válido);
         · al cerrar → foco al botón «All», el activador visible.
       En móvil no se hace nada: el ☰ es visible y Dawn ya funciona. */
    var panel = details.querySelector('.menu-drawer');

    function panelFocusables() {
      if (!panel) return [];
      var all = typeof window.getFocusableElements === 'function'
        ? window.getFocusableElements(panel)
        : Array.prototype.slice.call(panel.querySelectorAll('summary, a[href], button:enabled, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, [tabindex]:not([tabindex^="-"])'));
      return all.filter(function (el) {
        return el.offsetParent !== null || window.getComputedStyle(el).display !== 'none';
      });
    }

    /* Se comprueba que el foco haya entrado: mientras el panel arranca su
       transición puede seguir computando `visibility: hidden` y entonces
       `focus()` no hace nada. Tres intentos cortos y se deja de insistir. */
    function focusIntoPanel(attempt) {
      var items = panelFocusables();
      if (!items.length) return;
      var target = items[0];
      if (typeof window.trapFocus === 'function') {
        window.trapFocus(panel, target); // re-arma la trampa sobre el panel
      } else {
        target.focus();
      }
      if (panel.contains(document.activeElement)) return;
      if ((attempt || 0) >= 3) return;
      window.setTimeout(function () {
        if (details.classList.contains('menu-opening')) focusIntoPanel((attempt || 0) + 1);
      }, 60);
    }

    if (panel && window.MutationObserver) {
      var wasOpening = details.classList.contains('menu-opening');
      new MutationObserver(function () {
        var opening = details.classList.contains('menu-opening');
        if (opening === wasOpening) return;
        wasOpening = opening;
        if (!window.matchMedia(DESKTOP).matches) return;
        if (opening) focusIntoPanel(0);
        else proxy.focus();
      }).observe(details, { attributes: true, attributeFilter: ['class'] });
    }

    proxy.addEventListener('click', function (event) {
      event.preventDefault();
      openedByProxy = true;
      summary.click();
    });

    details.addEventListener('toggle', function () {
      proxy.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      if (!details.open && openedByProxy) {
        openedByProxy = false;
        // En desktop el ☰ está oculto: devolvemos el foco al botón que abrió el drawer.
        if (window.matchMedia(DESKTOP).matches) proxy.focus();
      }
    });
  }

  /* 3) Plegado de la barra de departamentos --------------------------------- */
  function initDeptBar(wrapper) {
    var bar = wrapper.querySelector('[data-tv-deptbar]');
    if (!bar || wrapper.tagName.toLowerCase() !== 'sticky-header') return;

    var lastY = window.pageYOffset;
    var ticking = false;
    var threshold = 120;

    function update() {
      var y = window.pageYOffset;
      if (y > lastY && y > threshold) {
        wrapper.classList.add('tv-header--dept-hidden');
      } else if (y < lastY) {
        wrapper.classList.remove('tv-header--dept-hidden');
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(update);
      },
      { passive: true }
    );
  }

  function init() {
    var wrapper = document.querySelector('.tv-header-wrapper');
    if (!wrapper) return;

    var forms = document.querySelectorAll('[data-tv-search]');
    for (var i = 0; i < forms.length; i++) initSearch(forms[i]);

    initDrawerProxy(wrapper);
    initDeptBar(wrapper);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  // El editor de temas recarga la sección: hay que volver a enlazar.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('.tv-header-wrapper')) init();
  });
})();
